module.exports = {
  message: {
    "Account": '用户管理',
    "Home page management": "主页管理",
    "Online magazine management": "飞云杂志管理",
    "Issue management": "主题管理",
    "Article management": "文章管理",
    "Sub-category management": "副类别管理",
    "User Listing": "用戶列表",
    "Role listing": "角色列表",
    "userName": "用户名称",
    "Status": "状态",
    "Search": "搜寻",
    "datagridresult": "条结果",
    "RoleName": "角色名称",
    "createdTime": "创建日期",
    "Add": "新增",
    "Delete": "刪除",
    "password": "密码",
    "Tel": "电话",
    "email": "电邮",
    "Role": "角色",
    "Active": "已启动",
    "Inactive": "尚未启动",
    "Save": "储存",
    "Cancel": "取消",
    "Confirm": "确认",
    "Warning": "警告",
    "RoleType": "角色类型",
    "Super Admin": "超級管理員",
    "Platform": "平台管理員",
    "FunctionSelection": "功能",
    "subCategoryName": "副类别",
    "Category": "类别",
    "subCategory": "副类别",
    "All": "--- 全部 ---",
    "selectDefault": "--- 默认 ---",
    "PleaseSelect": "--- 请选择 ---",
    "title": "标题",
    "issueNumber": "期号",
    "Job function": "相关职能",
    "occupation": "相关职业",
    "LogOut": "登出",
    "Issue": "Issue",
    "Resource library management": "Resource library management",
    "Resource category management": "Resource category management",
    "Link management": "Link management",
    "name": "name",
    "English": "英文",
    "Simplified Chinese": "简体",
    "Traditional Chinese": "繁体",
    "issueName": "主题",
    "HomePage": "主页",
    "userDetail": "用户资料",
    "roleDetail": "角色资料",
    "articleList": "文章列表",
    "articleDetail": "文章资料",
    "subCategoryList": "副类别列表",
    "subCategoryDetail": "副类别资料",
    "issueList": "主题列表",
    "issueDetail": "主题资料",
    "resourceList": "resourceList",
    "resourceDetail": "resourceDetail",
    "resourceCategoryList": "resourceCategoryList",
    "resourceCategoryDetail": "resourceCategoryDetail",
    "Course management": "课程管理",
    "courseImport": "Course Import",
    "Area Of Study management": "Area Of Study management",
    "areaOfStudyImport": "areaOfStudyImport",
    "Add Banner": "增加横幅",
    "Add hot picks": "增加热门",
    "Save as draft": "储存为草稿",
    "Publish": "发布",
    "Draft": "草稿",
    "Published": "已发布",
    "Banner": "横幅 (最少: 1; 最多: 5)",
    "Article title:": "文章标题:",
    "Hot picks": "热门 (必定是3)",
    "Ready to Publish": "准备发布",
    "Article title": "文章标题",
    "Preview": "预览",
    "Edit": "编辑",
    "Author/Interviewee name": "作者/受访者名称",
    "Author/Interviewee title": "作者/受访者标题",
    "Author/Interviewee icon": "作者/受访者头像",
    "Short description": "短述",
    "Facebook article ID": "Facebook文章ID",
    "Cover image": "封面图片",
    "Cover image alt text": "封面图片alt text",
    "Content editor": "内容编辑器",
    "Slideshow": "幻灯片",
    "Tags": "标签",
    "tagsTip": '利用 ";" 分隔标签',
    "Add tag": "增加标签",
    "Recommended articles": "推介文章",
    "Maximum 5": "最多5个",
    "Image size error": "图片档案大小错误！",
    "Dimension Error": "图片尺寸错误！",
    "deleteContent": "您确定要删除所选内容吗？",
    "Are you sure to publish": "您确定要发布吗？",
    "Are you sure to readyToPublish": "您确定要准备发布吗？",
    "Are you sure to edit": "您确定要将文章下架编辑吗？",
    "Must be 3": "一定要3個",
    "MinimumMaximum": "最少1個，最多10個",
    "Minimum 5 occupation": "最少5個職業",
    "floatingBanner": "浮动横幅",
    "Floating banner management": "浮动横幅管理",
    "floatingBannerList": "浮动横幅列表",
    "bannerImage": "横幅图片",
    "bannerName": "橫幅名称",
    "bannerContent": "横幅内容",
    "buttonUrl": "按钮链接",
    "floatingBannerDetail": "浮動橫幅资料",
    "Add floating banner": "增加浮动横幅",
    "FloatingBanner name:": "浮动横幅名称:",
    "FloatingBanner name": "浮动横幅名称",
    "FloatingBannerNum": "浮动横幅 (最少: 1; 最多: 5)",
    "updatedTime": "更新日期",
    "Department banner management": "部门横幅管理",
    "departmentBanner": "部门横幅",
    "departmentBannerList": "部门横幅列表",
    "Add department banner": "增加部门横幅",
    "DepartmentBanner name:": "部门横幅名称:",
    "DepartmentBanner name": "部门横幅名称",
    "departmentBannerDetail": "部门横幅资料",
    "DepartmentBannerNum": "部门横幅 (最少: 1)",
    "Banner management": "横幅管理",
    "Top banner management": "顶部横幅管理",
    "topBannerList": "顶部横幅列表",
    "topBannerDetail": "顶部横幅资料",
    "TopBanner name": "顶部横幅名称",
    "TopBanner name:": "顶部横幅名称:",
    "Name": "名称",
    "shortDescription": "简要说明",
    "url": "链接",
    "TopBannerNum": "顶部横幅 (最少: 1; 最多: 20)",
    "Add top banner": "增加顶部横幅",
    "topBanner": "顶部横幅",
    "Career magazine": "职业杂志",
    "Add magazine": "增加杂志",
    "Career magazineNum": "职业杂志 (必定是3)",
    "floating bannerContent": "浮动横幅内容",
    "Job import management": "职位空缺上传管理",
    "jobImportList": "职位空缺上传列表",
    "JobSource name": "职位空缺来源名称",
    "Period": "时间",
    "Import": "导入",
    "active": "已启动",
    "inactive": "取消启动",
    "Pending": "待派发",
    "Expired": "过期",
    "To": "至",
    "startTime": "开始时间",
    "endTime": "结束时间",
    "upload": "上传",
    "download": "下载模板",
    "lastFile": "上次上传档案",
    "last update time": "上次上传时间",
    "Instant Filter": "快速搜索 开/关",
    "On": "开",
    "Off": "关",
    "Instant filter status": "快速搜索状态",
    "Occupation management": "职业管理",
    "Resource management": "资讯管理",
    "Info Centre management": "资讯中心管理",
    "Quiz management": "小测试管理",
    "Quiz Popup": "小测试弹窗",
    "Import QR course": "QR课程上传",
    "Import CEF course": "CEF课程上传",
    "Import VTC CIP": "VTC-CIP / QR-CIP上传",
    "Import Area of Study": "学科上传",
    "Import Delivery mode": "学习模式上传",
    "Import Level": "课程级别上传",
    "Upload success": "上传成功",
    "Original Img": "原图上传",
    "Crop Img": "缩图上传",
    "Select file": "选择文件",
    "Import Occupation": "职业上传",
    "Import Info Centre": "资讯中心上传",
    "Import Resource": "资讯上传",
    "Import Tag": "标签上传",
    "System Theme management": "单色模式",
    "SaveSuccess": "储存成功",
    "StartTimeLessThanEndTime": "开始时间必须小于结束时间",
    "Eight Centres Management": "八大中心",
    "Import Content": "上传內容",
    "Centres Banner": "中心横幅",
    "Centres Title": "中心标题 (最少: 1; 最多: 8)",
     "Add Centres List": "增加中心列表",
    "Centres Name": "中心名称",
    "Centres Content": "八大中心内容",
    "Add Centres Content": "新增中心内容",
    "Sub-title": "副标题",
    "Manpower Projection": "人力推算",
    "icon image": "图示图片",
    "section1_title" : "人力推算 (年份)",
    "Manpower Projection for" : "人力推算",
    "From" : "由 ",
    "to" : "至 ",
    "section1_subTitle" : "副标题 (人力需求推算年份)",
    "section1_contentOfSubTitle": "人力需求推算 (数目)",
    "section1_subTitle2" : "推算期间 (年份)",
    "Projection change": "推算变动",
    "Annual change": "年均变动",
    "Sectoral Manpower Balance": "产业人力供求差额",
    "Manpower Balance by Occupation Group" : "按职业组别划分的人力供求差额",
    "section2_title" : "按职业组别划分的人力供求差额 (年份)",
    "Managers": "经理丶主管及专业人员",
    "Service": "服务从业人员",
    "Technical": "熟练技术人员",
    "Labourers": "非技术人员",
    "Key Factors Impacting Outlook" : "影响前景的关键因素",
    "section3_contents": "关键因素",
    "Occupations in Demand": "高需求职业",
    "section4_contents": "需求职业",
    "Essential Skills": "重要技能",
    "section5_contents": "技能",
    "Essential Knowledge": "必备知识",
    "section6_contents": "知识",
    "hongKongEightCentres": "八大中心",
    "descriptHongKongEightCentres": "探索国家《十四五规划纲要》中香港八个重点发展领域的工作机遇",
    "editText": "点选编辑文字...",
    "Add Factor": "增加因素",
    "Add Demand": "增加需求",
    "Add Section": "增加章节",
    "Add Skill": "增加技能",
    "Add Knowledge": "增加知识",
  }
}